import apiClient from './api';
import type { Shelf, ShelfCreate, ShelfUpdate, ShelfWithBooks } from '../types';

export const shelfService = {
  getAllShelves: async (params?: { skip?: number; limit?: number }): Promise<Shelf[]> => {
    const response = await apiClient.get('/api/shelves', { params });
    return response.data;
  },

  getAllShelvesIncludingEmpty: async (params?: { skip?: number; limit?: number }): Promise<Shelf[]> => {
    const response = await apiClient.get('/api/shelves/all', { params });
    return response.data;
  },

  getShelfNumbers: async (): Promise<string[]> => {
    const response = await apiClient.get('/api/shelves/dropdown');
    return response.data;
  },

  getShelf: async (id: number): Promise<ShelfWithBooks> => {
    const response = await apiClient.get(`/api/shelves/${id}`);
    return response.data;
  },

  createShelf: async (shelfData: ShelfCreate): Promise<Shelf> => {
    const response = await apiClient.post('/api/shelves', shelfData);
    return response.data;
  },

  updateShelf: async (id: number, shelfData: ShelfUpdate): Promise<Shelf> => {
    const response = await apiClient.put(`/api/shelves/${id}`, shelfData);
    return response.data;
  },

  deleteShelf: async (id: number): Promise<void> => {
    await apiClient.delete(`/api/shelves/${id}`);
  },
};
